import { Component, OnInit } from '@angular/core';
import { MyQaReviewService } from './services/my-qa-review.service';
import { MyQaReviewConstants } from './constants/my-qa-review.constants';
import { DocumentLibraryConstants } from '../document/document-library-constants';
import { LabelConstants } from '../shared/constants/label-constants';

@Component({
  selector: 'app-my-qa-reviews',
  templateUrl: './my-qa-reviews.component.html',
  styleUrls: ['./my-qa-reviews.component.scss']
})
export class MyQaReviewsComponent implements OnInit{
  topBarTitle:string = MyQaReviewConstants.MyQaReviews_TopBarTitle;
  showAllLabel:string=MyQaReviewConstants.MyQaReviews_ShowAllLabel;
  isIncludeAll = MyQaReviewConstants.MyQaReviews_IsIncludeAll;
  showInformationIconCheckbox = MyQaReviewConstants.MyQaReviews_ShowInformationIconCheckbox;
  inactiveTooltip:string = MyQaReviewConstants.MyQaReviews_CheckBoxHoverToolTip;
  documentSearchResult:any[] = [];
  panelListType:string = DocumentLibraryConstants.QaReview_PanelListType;
  showLoader: boolean = true;
  isScreenAccessible : boolean = true;
  errorMessage !: string;

  constructor(private myQaReviewService : MyQaReviewService){ 
  }


  ngOnInit(): void {
    this.getPanelListData(this.isIncludeAll);
  }
  
    includeInactive(isIncludeAll: boolean) {
        this.showLoader = true;
    this.getPanelListData(isIncludeAll);
  }

  getPanelListData(isIncludeAll:boolean){
      this.myQaReviewService.getMyQaReviews(isIncludeAll).subscribe({
          error: (err) => {
              if (err.status === LabelConstants.Forbidden_StatusCode) {
                  this.errorMessage = err.error.detail;
              }
              this.isScreenAccessible = false
          },
          next: (serviceData) => {
              this.documentSearchResult = serviceData;
              this.showLoader = false;
          }
    });
  }
}
